import { Download } from "@mui/icons-material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import MoreVertOutlinedIcon from "@mui/icons-material/MoreVertOutlined";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import {
  Box,
  CircularProgress,
  Grid2,
  IconButton,
  MenuItem,
  Step,
  StepLabel,
  TableCell,
  Typography,
  useTheme,
} from "@mui/material";
import moment from "moment";
import React, { Fragment, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { DownloadResume } from "../../../api/Api";
import CandidateHub from "../../../assets/icons/CandidateHub";
import DeleteIco from "../../../assets/icons/DeleteIco";
import EyeIco from "../../../assets/icons/EyeIco";
import PageStepperDefaultIco from "../../../assets/icons/PageStepperDefaultIco";
import ReportBugIco from "../../../assets/icons/ReportBugIco";
import StepperActiveIco from "../../../assets/icons/StepperActiveIco";
import StepperInprogressIco from "../../../assets/icons/StepperInprogressIco";
import SupportIco from "../../../assets/icons/SupportIco";
import Breadcrumbs from "../../../component/Breadcrumbs";
import CommonButton from "../../../component/Button";
import SnackBar from "../../../component/SnackBar";
import {
  CandidateAttachementCreateCall,
  CandidateAttachementDelete,
  CandidateAttachementDownload,
  CandidateAttachementTableGetCall,
  CandidateDelete,
  CandidateEditProfile,
  CandidateEnrichResume,
  CandidateStatusChange,
  CandidateViewCall,
} from "../../../redux/action/Candidate";
import { SupportCall, SupportGetCall } from "../../../redux/action/ChatBot";
import { SendInterest } from "../../../redux/action/CoverSheet";
import { FeedBackButton } from "../../../redux/action/Feedback";
import { JobResumeDuplicate } from "../../../redux/action/Job";
import { MinimizeIcon } from "../../../redux/action/Login";
import {
  ResumeIntelligenceDeleteNote,
  ResumeIntelligenceFix,
  ResumeIntelligenceGETNote,
  ResumeIntelligencePostNote,
  ResumeIntelligencePutNote,
  ResumeIntelligenceSave,
  ResumeIntelligenceUpload,
  ResumeIntelligenceUploadResume,
} from "../../../redux/action/ResumeIntelligence";
import { GETDOWNLOAD } from "../../../redux/axios/Axios";
import CommonTable from "../../candidates/Table";
import ChatBotLabelText from "../../chat-bot/ChatBotLabelText";
import SideBarChatBot from "../../chat-bot/SIdeBarChatBot";
import { CustomDiv } from "../../chat-bot/style";
import SkillDeleteDialog from "../../common-components/DeleteDialog";
import NewDeleteNote from "../../common-components/NewDeleteNote";
import {
  CommonGrid2,
  DotColor,
  ScoreChange,
  StatusChange,
  StyledFlexRowView,
  StyledTableBodyTableCell,
} from "../../common-components/StyledComponents";
import AttachmentDialog from "../../jobs/jobs-candidate/components/AttachementDialog";
import InteractionDialog from "../../jobs/jobs-candidate/components/Dialogbox";
import DialogCandidateHub from "../../jobs/jobs-candidate/components/DialogCandidateHub";
import EditCandidateProfile from "../../jobs/jobs-candidate/components/EditCandidateDialog";
import { CustomizeMenu } from "../../jobs/style";
import { StepperStyle } from "../../matches/quick-match/style";
import CandidateResume from "./components/CandidateResume";
import ResumeCreateNote from "./components/CreateNote";
import ReviewCandidateProfile from "./components/ReviewCandidateProfile";
import UploadCandidateResume from "./components/UploadCandidateResume";
import useMeasure from "react-use-measure";

function CreateCandidateResume() {
  const [ref, bounds] = useMeasure();
  const [value, setValue] = useState(0);
  const [isDragging, setIsDragging] = useState(false);
  const [files, setFiles] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [snackbarState, setSnackbarState] = useState({
    open: false,
    message: "",
    severity: "error",
  });
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);
  const theme = useTheme();
  const allowedTypes = [
    "application/pdf",
    "application/msword",
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  ];
  const limit = 5;
  const location = useLocation();
  const [resumeLoading, setResumeLoading] = useState(false);
  const [viewResume, setViewResume] = useState({
    open: false,
    disabled: false,
    duplicateLoading: false,
    replacedLoading: false,
    leaveLoading: false,
  });
  const [deleteTableRow, setDeleteTableRow] = useState({
    open: false,
    loading: false,
    content: "",
    id: "",
  });
  const [isRequestLoading, setIsRequestLoading] = useState(false);
  const layout = useSelector((state) => state.layout.layout);
  const [chatBotData, setChatBotData] = useState({
    message: [
      { sender: "bot", text: "Hi, I am Hailey. How can I assist you today?" },
    ],
    value: "",
    loader: false,
    pageLoader: false,
    arrow: true,
    bubble: [],
    bubbleCondition: false,
    selectedValue: "Support",
    expandDrawer: false,
  });
  const [isBottomVisible, setIsBottomVisible] = useState(true);
  const [copied, setCopied] = useState(false);
  const [downloadMenuLoader, setDownloadMenuLoader] = useState(false);
  const [resumeData, setResumeData] = useState({});
  const navigate = useNavigate();
  const query = new URLSearchParams(useLocation().search);
  const [fixOpen, setFixOpen] = useState(false);
  const [resumeIntelligenceSave, setResumeIntelligenceSave] = useState({});
  const [candidateList, setCandidateList] = useState({
    data: [],
    currentPage: 1,
    totalPage: "",
    loading: false,
  });
  const [tabData, setTabData] = useState([
    {
      label: "Upload Candidate Resume",
      status: "In Progress",
    },
    {
      label: "Scoring",
      status: "Pending",
    },
    {
      label: "Review Candidate Profile",
      status: "Pending",
    },
  ]);
  const headerData = [
    { name: "Name", direction: "asc", sort: false },
    { name: "Title", direction: "asc", sort: false },
    { name: "Status", direction: "asc", sort: false },
    { name: "Score", direction: "asc", sort: false },
    {},
  ];
  const [noteHeaderData, setNoteHeaderData] = useState([
    { name: "Title", direction: "asc", sort: false, width: "50%" },
    { name: "Created By", direction: "asc", sort: false, width: "20%" },
    { name: "Date", direction: "asc", sort: false, width: "15%" },
    { width: "15%" },
  ]);
  const buttonSupport = [
    {
      name: "Support",
      icon: <SupportIco />,
    },
    {
      name: "Report Bug",
      icon: <ReportBugIco />,
    },
  ];
  const [openNote, setOpenNote] = useState({
    loading: false,
    open: false,
    note: "",
    id: "",
    deleteNote: false,
    created_at: "",
  });
  const [notesTableList, setNotesTableList] = useState([]);
  const resumeIntelligence = useSelector(
    (state) => state.resumeIntelligence.resumeIntelligenceSave
  );
  const [fixLoading, setFixLoading] = useState(false);
  const [notesTableListLoading, setNotesTableListLoading] = useState(false);
  const localStorageData = JSON.parse(localStorage.getItem("credential"));
  const resumeIntelligenceUpload = useSelector(
    (state) => state.resumeIntelligence.resumeIntelligenceUpload
  );
  const [viewFullRecord, setViewFullRecord] = useState(true);
  const interactionHeaderdata = [
    { name: "ID", direction: "asc", sort: false },
    { name: "Made By", direction: "asc", sort: false },
    { name: "Type", direction: "asc", sort: false },
    { name: "Action", direction: "asc", sort: false },
    { name: "Status", direction: "asc", sort: false },
    { name: "Created At", direction: "asc", sort: false },
    { width: "5%" },
  ];
  const resumeIdFromUrl = query.get("resume_id");
  const [editDialog, setEditDialog] = useState({
    open: false,
    disabled: false,
    cancelLoading: false,
    saveLoading: false,
  });
  const [interAction, setInterAction] = useState({
    data: {},
    open: false,
  });
  const [attachmentList, setAttachmentList] = useState({
    data: [],
    loading: false,
  });
  const [attachementHeaderData, setAttachementHeaderData] = useState([
    { name: "Name", width: "23%" },
    { name: "Type", width: "20%" },
    { name: "Status" },
    { name: "Created by" },
    { name: "Created Date" },
    {},
  ]);
  const statusOptions = [
    { name: "Active", color: "#17B26A", id: "Active" },
    { name: "Unavailable", color: "#9E77ED", id: "Unavailable" },
    { name: "Inactive", color: "#667085", id: "Inactive" },
    { name: "Do Not Hire", color: "#F04438", id: "Do Not Hire" },
  ];
  const [anchorEl, setAnchorEl] = useState(null);
  const attachementOpen = Boolean(anchorEl);
  const [attachmentDialog, setAttachmentDialog] = useState({
    loading: false,
    disabled: false,
    open: false,
  });
  const [attachementMenuLoader, setAttachementMenuLoader] = useState({
    download: false,
    view: false,
  });
  const [attachementRowData, setAttachementRowData] = useState({});
  const [deleteButton, setDeleteButton] = useState({
    loading: false,
    open: false,
    content: "",
    id: "",
  });
  const [statusDialog, setStatusDialog] = useState({
    open: false,
    disabled: false,
    noLoading: false,
    yesLoading: false,
    value: "",
  });

  const [breadCrumbShow, setBreadCrumbShow] = useState(false);
  const breadCrumbData = [
    {
      title: "Scoring Result",
      navigate: "/resume-intelligence/create-candidate-resume?value=2",
    },
    {
      title: "View Record",
      active: true,
    },
  ];
  const gridData = (data) => [
    {
      title: "Experience",
      contentKey: data?.personal_details?.experience_years || "-",
    },
    {
      title: "Location",
      contentKey: data?.personal_details?.location || "-",
      icon: data?.personal_details?.location_flag,
    },
    {
      title: "Email Adress",
      contentKey: data?.personal_details?.email || "-",
    },

    {
      title: "Phone Number",
      contentKey: data?.personal_details?.phone_number || "-",
      isLink: true,
    },
  ];

  const reviewGridData = (data) => [
    {
      title: "Industries",
      contentKey: data?.personal_details?.industry_info || [],
    },
    {
      title: "Occupational Classification",
      contentKey:
        data?.personal_details?.occupational_classification_info || [],
    },
    {
      title: "Countries",
      contentKey: data?.personal_details?.country_info || [],
    },
    { title: "Website", isLink: "-" },
  ];
  const [scoringResult, setScoringResult] = useState([
    {
      title: "New Resumes",
      data: resumeIntelligenceUpload.data?.new_resumes,
      name: "new_resumes",
      record: "View Record",
      toggles: [],
    },
    {
      title: "Needs Review",
      data: resumeIntelligenceUpload.data?.need_review,
      name: "need_review",
      record: "View Record",
      toggles: [],
    },
    {
    title: "Error Occured",
    data: resumeIntelligenceUpload.data?.error_occured || [],
    name: "error_occured",
    toggles: [],
  },
    
  ]);

  const handleDetails = (index, recordIndex) => {
    setScoringResult((prev) =>
      prev.map((item, i) =>
        i === index
          ? {
              ...item,
              toggles: item.toggles.map((toggle, j) =>
                j === recordIndex
                  ? toggle === "See Details"
                    ? "Hide Details"
                    : "See Details"
                  : toggle
              ),
            }
          : item
      )
    );
  };


  const uploadFile = async () => {
    setIsLoading(true);
    setFiles((prevFiles) =>
      prevFiles.map((f) => ({
        ...f,
        delete: false,
        message: "",
        visible: false,
      }))
    );
    setTabData((prev) =>
      prev.map((tab, index) =>
        index < 1
          ? { ...tab, status: "Completed" }
          : index === 1
          ? { ...tab, status: "In Progress" }
          : tab
      )
    );
    setValue(1);

    if (
      localStorageData?.organization === "Demo" &&
      localStorageData?.role === "Demo"
    ) {
      try {
        const data = await dispatch(
          CandidateViewCall(localStorageData?.demo_config?.demo_resume)
        );
        setResumeData(data);
        const interval = setInterval(() => {
          setFiles((prevFiles) =>
            prevFiles.map((f) => {
              const updatedProgress = f.progress + 10;
              const isComplete = updatedProgress >= 100;

              if (isComplete) {
                clearInterval(interval);

                setTimeout(() => {
                  setTabData((prev) =>
                    prev.map((tab, index) =>
                      index <= 2 ? { ...tab, status: "Completed" } : tab
                    )
                  );

                  setValue(2);
                  setSnackbarState({
                    open: true,
                    message: "Update Successfully",
                    severity: "success",
                  });
                }, 500);

                return { ...f, progress: 100, buffer: 100 };
              }

              return {
                ...f,
                progress: updatedProgress,
                buffer: updatedProgress,
                visible: false,
                delete: false,
              };
            })
          );
        }, 300);

        setTimeout(() => clearInterval(interval), 4000);
      } catch (error) {
        setTabData((prev) =>
          prev.map((tab, index) =>
            index === 0
              ? { ...tab, status: "In Progress" }
              : index === 1
              ? { ...tab, status: "Pending" }
              : tab
          )
        );

        setValue(1);
        setSnackbarState({
          open: true,
          message: "Error parsing JSON",
          severity: "error",
        });
      }
    } else {
      const storedData = JSON.parse(
        localStorage.getItem("CandidateEnrichResume")
      );
      const formData = new FormData();

      files.forEach((fileObj, index) => {
        formData.append("files", fileObj.file);
      });

      try {
        const response = await ResumeIntelligenceUpload(formData);
        const reader = response.body.getReader();
        const decoder = new TextDecoder("utf-8");
        let buffer = "";

        while (true) {
          const { value, done } = await reader.read();
          if (done) break;
          const chunk = decoder.decode(value, { stream: true });
          buffer += chunk;
          let boundaryIndex;
          while ((boundaryIndex = buffer.indexOf("}\n")) !== -1) {
            const jsonString = buffer.slice(0, boundaryIndex + 1);
            buffer = buffer.slice(boundaryIndex + 1);
            const jsonResponse = JSON.parse(jsonString);
            try {
              await processJsonResponse(jsonResponse);
            } catch (e) {
              setTabData((prev) =>
                prev.map((tab, index) =>
                  index === 0
                    ? { ...tab, status: "Inprogress" }
                    : index === 1
                    ? { ...tab, status: "Pending" }
                    : tab
                )
              );
              setValue(0);
              const getData = storedData?.file?.map((f) =>
                f.name === jsonResponse.data.current_resume
                  ? {
                      ...f,
                      visible: true,
                      delete: true,
                      message: jsonResponse.message,
                    }
                  : { ...f, delete: true }
              );

              localStorage.setItem(
                "CandidateEnrichResume",
                JSON.stringify({
                  file: getData,
                  status: "fail",
                })
              );
              dispatch(
                ResumeIntelligenceUploadResume({
                  file: getData,
                  status: "fail",
                })
              );
              setFiles((prevFiles) =>
                prevFiles.map((f) =>
                  f.name === jsonResponse.data.current_resume
                    ? {
                        ...f,
                        visible: true,
                        delete: true,
                        message: jsonResponse.message,
                      }
                    : { ...f, delete: true }
                )
              );

              setSnackbarState({
                open: true,
                message: "Error parsing JSON",
                severity: "error",
              });
              setIsLoading(false);
            }
          }
        }

        if (buffer) {
          const jsonResponse = JSON.parse(buffer);
          try {
            await processJsonResponse(jsonResponse);
          } catch (e) {
            setTabData((prev) =>
              prev.map((tab, index) =>
                index === 0
                  ? { ...tab, status: "Inprogress" }
                  : index === 1
                  ? { ...tab, status: "Pending" }
                  : tab
              )
            );

            const getData = storedData?.file?.map((f) =>
              f.name === jsonResponse.data.current_resume
                ? {
                    ...f,
                    visible: true,
                    delete: true,
                    message: jsonResponse.message,
                  }
                : { ...f, delete: true }
            );

            localStorage.setItem(
              "CandidateEnrichResume",
              JSON.stringify({
                file: getData,
                status: "fail",
              })
            );
            dispatch(
              ResumeIntelligenceUploadResume({
                file: getData,
                status: "fail",
              })
            );
            setFiles((prevFiles) =>
              prevFiles.map((f) =>
                f.name === jsonResponse.data.current_resume
                  ? {
                      ...f,
                      visible: true,
                      delete: true,
                      message: jsonResponse.message,
                    }
                  : { ...f, delete: true }
              )
            );

            setSnackbarState({
              open: true,
              message: "Error parsing final JSON chunk",
              severity: "error",
            });
          }
        }
        setIsLoading(false);
      } catch (error) {
        setTabData((prev) =>
          prev.map((tab, index) =>
            index === 0
              ? { ...tab, status: "Inprogress" }
              : index === 1
              ? { ...tab, status: "Pending" }
              : tab
          )
        );

        const getData = storedData?.file?.map((f) => ({
          ...f,
          visible: true,
          delete: true,
          message: '"Error during the request',
        }));

        localStorage.setItem(
          "CandidateEnrichResume",
          JSON.stringify({
            file: getData,
            status: "fail",
          })
        );
        dispatch(
          ResumeIntelligenceUploadResume({
            file: getData,
            status: "fail",
          })
        );

        setValue(0);
        setFiles((prevFiles) =>
          prevFiles.map((f) => ({
            ...f,
            visible: true,
            delete: true,
            message: "Error during the request",
          }))
        );

        setSnackbarState({
          open: true,
          message: "Error during the request",
          severity: "error",
        });

        setIsLoading(false);
      }
    }
  };

  // const processJsonResponse = (jsonResponse) => {
  //   const { success, data, message } = jsonResponse;

  //   if (success && data?.percent !== undefined) {
  //     const storedData = JSON.parse(
  //       localStorage.getItem("CandidateEnrichResume")
  //     );
  //     const getData = storedData?.file?.map((f) =>
  //       f.name === data.current_resume
  //         ? {
  //             ...f,
  //             progress: data.percent,
  //             buffer: data.percent,
  //             visible: false,
  //             progress_message: data.progress_message,
  //           }
  //         : f
  //     );

  //     localStorage.setItem(
  //       "CandidateEnrichResume",
  //       JSON.stringify({
  //         file: getData,
  //         status: "process",
  //       })
  //     );
  //     dispatch(
  //       ResumeIntelligenceUploadResume({
  //         file: getData,
  //         status: "process",
  //       })
  //     );
  //     setFiles(getData);
  //     return;
  //   }
  //  if (!success && data?.current_resume && !data?.error_occured) {
  //   const storedData = JSON.parse(localStorage.getItem("CandidateEnrichResume"));
  //   const getData = storedData?.file?.map((f) =>
  //     f.name === data.current_resume
  //       ? { ...f, visible: false, delete: false }
  //       : f
  //   );
  //   localStorage.setItem("CandidateEnrichResume", JSON.stringify({ file: getData, status: "process" }));
  //   dispatch(ResumeIntelligenceUploadResume({ file: getData, status: "process" }));
  //   setFiles(getData);
  //   return;
  // }
  //  else if (
  //     data?.need_review?.length !== 0 ||
  //     data?.new_resumes?.length !== 0
  //   ) {
  //     localStorage.setItem(
  //       "CandidateEnrichResume",
  //       JSON.stringify({
  //         file: [],
  //         status: "process",
  //       })
  //     );
  //     dispatch(
  //       ResumeIntelligenceUploadResume({
  //         data: data,
  //         file: [],
  //         status: "success",
  //       })
  //     );
  //     setResumeData(data);
  //     setSnackbarState({
  //       open: true,
  //       message: message,
  //       severity: "success",
  //     });
  //     setTabData((prev) =>
  //       prev.map((tab, index) =>
  //         index <= 2 ? { ...tab, status: "Completed" } : tab
  //       )
  //     );
  //     setValue(2);
  //     setScoringResult([
  //       {
  //         title: "New Resumes",
  //         data: data?.new_resumes,
  //         name: "new_resumes",
  //         toggles: Array(data?.new_resumes?.length || 0).fill("Hide Details"),
  //         record: "View Record",
  //       },
  //       {
  //         title: "Needs Review",
  //         data: data?.need_review,
  //         toggles: Array(data?.need_review?.length || 0).fill("Hide Details"),
  //         name: "need_review",
  //         record: "View Record",
  //       },
  //     ]);
  //     setBreadCrumbShow(true);
  //     navigate("/resume-intelligence/create-candidate-resume?value=2");
  //   } else if (!success) {
  //     const storedData = JSON.parse(
  //       localStorage.getItem("CandidateEnrichResume")
  //     );
  //     const getData = storedData?.file?.map((prevFiles) =>
  //       prevFiles.map((f) =>
  //         f.name === data.current_resume || data.length == 0
  //           ? {
  //               ...f,
  //               visible: true,
  //               delete: true,
  //               message: message,
  //             }
  //           : { ...f, delete: true }
  //       )
  //     );

  //     localStorage.setItem(
  //       "CandidateEnrichResume",
  //       JSON.stringify({
  //         file: getData,
  //         status: "fail",
  //       })
  //     );
  //     dispatch(
  //       ResumeIntelligenceUploadResume({
  //         file: getData,
  //         status: "fail",
  //       })
  //     );
  //     setFiles(getData);
  //     setSnackbarState({
  //       open: true,
  //       message: data.message,
  //       severity: "error",
  //     });
  //     setIsLoading(false);
  //   }
  // };
const processJsonResponse = (jsonResponse) => {
  const { success, data, message } = jsonResponse;

  // Progress tick
  if (success && data?.percent !== undefined) {
    const storedData = JSON.parse(localStorage.getItem("CandidateEnrichResume"));
    const getData = storedData?.file?.map((f) =>
      f.name === data.current_resume
        ? {
            ...f,
            progress: data.percent,
            buffer: data.percent,
            visible: false,
            progress_message: data.progress_message,
          }
        : f
    );
    localStorage.setItem("CandidateEnrichResume", JSON.stringify({ file: getData, status: "process" }));
    dispatch(ResumeIntelligenceUploadResume({ file: getData, status: "process" }));
    setFiles(getData);
    return;
  }

  // Per-file streaming error chunk (has current_resume, not the final summary)
  if (!success && data?.current_resume && !data?.error_occured) {
    const storedData = JSON.parse(localStorage.getItem("CandidateEnrichResume"));
    const getData = storedData?.file?.map((f) =>
      f.name === data.current_resume
        ? { ...f, visible: false, delete: false }
        : f
    );
    localStorage.setItem("CandidateEnrichResume", JSON.stringify({ file: getData, status: "process" }));
    dispatch(ResumeIntelligenceUploadResume({ file: getData, status: "process" }));
    setFiles(getData);
    return;
  }

  // Final response — success, partial, or all-failed
  const newResumes  = data?.new_resumes   || [];
  const needReview  = data?.need_review   || [];
  const failedItems = data?.error_occured || [];

  const hasAnyFinalResult =
    newResumes.length > 0 || needReview.length > 0 || failedItems.length > 0;

  if (hasAnyFinalResult) {
    localStorage.setItem("CandidateEnrichResume", JSON.stringify({ file: [], status: "success" }));
    dispatch(ResumeIntelligenceUploadResume({ data, file: [], status: "success" }));
    setResumeData(data);
    setSnackbarState({
      open: true,
      message: message,
      severity: newResumes.length > 0 || needReview.length > 0 ? "success" : "error",
    });
    setTabData((prev) =>
      prev.map((tab, index) => (index <= 2 ? { ...tab, status: "Completed" } : tab))
    );
    setValue(2);
    setScoringResult([
      {
        title: "New Resumes",
        data: newResumes,
        name: "new_resumes",
        toggles: Array(newResumes.length).fill("Hide Details"),
        record: "View Record",
      },
      {
        title: "Needs Review",
        data: needReview,
        name: "need_review",
        toggles: Array(needReview.length).fill("Hide Details"),
        record: "View Record",
      },
      {
        title: "Error Occured",
        data: failedItems,
        name: "error_occured",
        toggles: Array(failedItems.length).fill("Hide Details"),
      },
    ]);
    setBreadCrumbShow(true);
    navigate("/resume-intelligence/create-candidate-resume?value=2");
  }
};
  const handleCloseValidation = () => {
    setSnackbarState((prev) => ({
      ...prev,
      open: false,
    }));
  };

  const commonFileValidationCheck = (
    commonFiles,
    allowedTypes,
    setCommonFiles,
    existingFiles
  ) => {
    const validFiles = [];
    const invalidFiles = [];

    commonFiles.forEach((file) => {
      if (allowedTypes.includes(file.type)) {
        validFiles.push({
          file,
          name: file.name,
          size: `${(file.size / 1024).toFixed(1)} KB`,
          type: file.type,
          progress: 0,
          buffer: 0,
          visible: false,
          delete: true,
          message: "",
        });
      } else {
        invalidFiles.push(file.name);
      }
    });

    const mergedFiles = [
      ...existingFiles,
      ...validFiles.filter(
        (newFile) =>
          !existingFiles.some(
            (existingFile) => existingFile.name === newFile.name
          )
      ),
    ];
    setCommonFiles(mergedFiles);

    if (invalidFiles.length > 0) {
      setSnackbarState({
        open: true,
        message: `Unsupported file types: ${invalidFiles.join(", ")}`,
        severity: "error",
      });
    } else {
      setTabData((prev) =>
        prev.map((tab, index) =>
          index === 0 ? { ...tab, status: "Completed" } : tab
        )
      );

      const updated = {
        file: mergedFiles.map((f) => ({
          ...f,
          progress: 0,
          buffer: 0,
          visible: false,
          delete: false,
          file: {
            name: f.file.name,
            size: f.file.size,
            type: f.file.type,
            lastModified: f.file.lastModified,
            ...f.file,
          },
        })),
        status: "InProgress",
      };

      localStorage.setItem("CandidateEnrichResume", JSON.stringify(updated));
      dispatch(
        ResumeIntelligenceUploadResume({
          file: updated.file,
          status: "InProgress",
        })
      );
      setValue(1);
    }
  };

  const handleFileUpload = (event) => {
    const selectedFiles = Array.from(event.target.files);
    commonFileValidationCheck(selectedFiles, allowedTypes, setFiles, files);
  };

  // Handle file deletion
  const handleDeleteFile = (index) => {
    const filterData = resumeIntelligenceUpload.file.filter(
      (_, i) => i !== index
    );

    dispatch(
      ResumeIntelligenceUploadResume({ file: filterData, status: "InProgress" })
    );
    setFiles((prevFiles) => {
      if (prevFiles.length === 1) {
        setTabData((prev) =>
          prev.map((tab, index) =>
            index === 0
              ? { ...tab, status: "In Progress" }
              : { ...tab, status: "Pending" }
          )
        );
        setValue(0);
      }
      return prevFiles.filter((_, i) => i !== index);
    });
  };

  const handleNextUploadClick = async () => {
    if (files.length == 0) {
      setSnackbarState({
        open: true,
        message: "Upload the Files",
        severity: "error",
      });
    } else {
      uploadFile();
    }
  };

  // Drag-and-drop functionality
  const handleDragOver = (event) => {
    event.preventDefault();
    setIsDragging(true);
  };

  const handleDragLeave = () => {
    setIsDragging(false);
  };

  const handleDrop = (event) => {
    event.preventDefault();
    setIsDragging(false);

    const selectedFiles = Array.from(event.dataTransfer.files);
    commonFileValidationCheck(selectedFiles, allowedTypes, setFiles, files);
  };

  const Footer = () => (
    <CommonGrid2 display={"flex"} gap={"1rem"}>
      <CommonButton
        value={"Ok"}
        width={"100%"}
        padding={"10px"}
        marginTop={"2rem"}
        fontWeight={"700"}
        fontSize={"15px"}
        onClick={handleFixClose}
      />
    </CommonGrid2>
  );
  const handleFixClose = () => {
    setFixOpen(false);
  };

  const handleScoreFix = async () => {
     if (!query.get("resume_id")){
    setFixOpen(true);
  }  else {
      setFixLoading(true);
      try {
        const data = await ResumeIntelligenceFix(resumeIntelligence.data.id);
        setFixLoading(false);
        setResumeLoading(true);
        setSnackbarState({
          open: true,
          message: data.message,
          severity: "success",
        });
        const fixData = await dispatch(
          CandidateViewCall(resumeIntelligence.data.id)
        );
        setResumeData(fixData);
        setTimeout(() => {
          setResumeLoading(false);
        }, 1000);
      } catch (error) {
        setFixLoading(false);
        setSnackbarState({
          open: true,
          message: error.message,
          severity: "error",
        });
      }
    }
  };

  useEffect(() => {
  const resumeIdFromUrl = query.get("resume_id");
  if (resumeIdFromUrl && value !== 2) {
    handleCandidateViewCall({ id: resumeIdFromUrl });
    setTabData((prev) =>
      prev.map((tab, index) =>
        index <= 1
          ? { ...tab, status: "Completed" }
          : { ...tab, status: "In Progress" }
      )
    );
    setValue(2);
     const fetchData = async () => {
      setIsLoading(true);
      try {
        const data = await dispatch(CandidateViewCall(resumeIdFromUrl));
        setResumeData(data);
        setIsLoading(false);
      } catch (error) {
        setSnackbarState({
          open: true,
          severity: "error",
          message: error?.data?.message || error.message,
        });
        setIsLoading(false);
      }
    };

    fetchData();
  }
  
}, []);
  useEffect(() => {
    if (
      resumeIntelligenceUpload.file &&
      resumeIntelligenceUpload.file.length !== 0 &&
      resumeIntelligenceUpload.status === "fail"
    ) {
      setIsLoading(false);
      setFiles(resumeIntelligenceUpload.file);
      setTabData((prev) =>
        prev.map((tab, index) =>
          index === 0
            ? { ...tab, status: "In Progress" }
            : index === 1
            ? { ...tab, status: "Pending" }
            : tab
        )
      );
      setValue(0);
    } else if (
      resumeIntelligenceUpload.file &&
      resumeIntelligenceUpload.file.length !== 0 &&
      resumeIntelligenceUpload.status === "process"
    ) {
      setIsLoading(true);
      setFiles(resumeIntelligenceUpload.file);
      setTabData((prev) =>
        prev.map((tab, index) =>
          index === 0
            ? { ...tab, status: "Completed" }
            : index === 1
            ? { ...tab, status: "In Progress" }
            : tab
        )
      );
      setValue(1);
    } else if (
      resumeIntelligenceUpload.data &&
      resumeIntelligenceUpload.data?.need_review &&
      (value == 0 || value === 1)
    ) {
      setIsLoading(false);
      setFiles([]);
      setTabData((prev) =>
        prev.map((tab, index) =>
          index <= 1
            ? { ...tab, status: "Completed" }
            : { ...tab, status: "In Progress" }
        )
      );
      setScoringResult([
        {
          title: "New Resumes",
          data: resumeIntelligenceUpload.data?.new_resumes,
          name: "new_resumes",
          toggles: Array(
            resumeIntelligenceUpload.data?.new_resumes?.length || 0
          ).fill("Hide Details"),
          record: "View Record",
        },
        {
          title: "Needs Review",
          data: resumeIntelligenceUpload.data?.need_review,
          toggles: Array(
            resumeIntelligenceUpload.data?.need_review?.length || 0
          ).fill("Hide Details"),
          name: "need_review",
          record: "View Record",
        },
           {
      title: "Error Occured",
      data: resumeIntelligenceUpload.data?.error_occured || [],
      name: "error_occured",
      toggles: Array(resumeIntelligenceUpload.data?.error_occured?.length || 0).fill("Hide Details"),
    },
      ]);

      setValue(2);
    }
  }, [resumeIntelligenceUpload]);

  useEffect(() => {
  const resumeIdFromUrl = query.get("resume_id");

  
  if (resumeIdFromUrl) return;
    if (
      resumeIntelligenceUpload.data &&
      resumeIntelligenceUpload?.status === "" &&
      resumeIntelligenceUpload.file.length === 0 &&
      Object.keys(resumeIntelligenceUpload.data).length === 0
    ) {
      window.history.replaceState(
        {},
        "",
        "/resume-intelligence/create-candidate-resume"
      );
      setValue(0);
      setTabData((prev) =>
        prev.map((tab, index) =>
          index === 0
            ? { ...tab, status: "In Progress" }
            : { ...tab, status: "Pending" }
        )
      );
    } else if (
      window.location.search === "value=2" &&
      resumeIntelligenceUpload.data &&
      resumeIntelligenceUpload?.status === "success"
    ) {
      setIsLoading(false);
      setFiles([]);
      setTabData((prev) =>
        prev.map((tab, index) =>
          index <= 1
            ? { ...tab, status: "Completed" }
            : { ...tab, status: "In Progress" }
        )
      );
      setScoringResult([
        {
          title: "New Resumes",
          data: resumeIntelligenceUpload.data?.new_resumes,
          name: "new_resumes",
          toggles: Array(
            resumeIntelligenceUpload.data?.new_resumes?.length || 0
          ).fill("Hide Details"),
          record: "View Record",
        },
        {
          title: "Needs Review",
          data: resumeIntelligenceUpload.data?.need_review,
          toggles: Array(
            resumeIntelligenceUpload.data?.need_review?.length || 0
          ).fill("Hide Details"),
          name: "need_review",
          record: "View Record",
        },
        {
    title: "Error Occured",
    data: resumeIntelligenceUpload.data?.error_occured || [],
    name: "error_occured",
    toggles: Array(resumeIntelligenceUpload.data?.error_occured?.length || 0).fill("Hide Details"),
  },
      ]);
      setBreadCrumbShow(true);
      setValue(2);
    } else if (
      window.location.search === "" &&
      resumeIntelligenceUpload.data &&
      resumeIntelligenceUpload?.status === "success"
    ) {
      setValue(0);
      setTabData((prev) =>
        prev.map((tab, index) =>
          index === 0
            ? { ...tab, status: "In Progress" }
            : { ...tab, status: "Pending" }
        )
      );
    }
  }, [location]);

  const [saveCandidateOpen, setSaveCandidateOpen] = useState({
    open: false,
    loading: false,
    disabled: false,
    leaveLoading: false,
  });

  const handleSaveLeave = async (action) => {
    let params = {
      action: action,
      resume_id: resumeData.id,
    };
    setSaveCandidateOpen((prev) => ({
      ...prev,
      disabled: true,
      leaveLoading: true,
    }));
    try {
      const data = await JobResumeDuplicate(params);
      setResumeIntelligenceSave(data?.data);
      setSnackbarState({
        open: true,
        severity: "success",
        message: data?.message,
      });
      handleSaveCandidateClose();
      navigate("/resume-intelligence/create-candidate-resume");
      setValue(0);
      setTabData((prev) =>
        prev.map((tab, index) =>
          index === 0
            ? { ...tab, status: "In Progress" }
            : index === 1
            ? { ...tab, status: "Pending" }
            : tab
        )
      );
    } catch (error) {
      setSnackbarState({
        open: true,
        severity: "error",
        message: error.message,
      });
      setSaveCandidateOpen((prev) => ({
        ...prev,
        loading: false,
        leaveLoading: false,
        disabled: false,
      }));
    }
  };

  const SaveCandidateFooter = () => (
    <CommonGrid2 display={"flex"} gap={"1rem"}>
      <CommonButton
        value={"Leave"}
        variant="outlined"
        width={"100%"}
        padding={"10px"}
        marginTop={"2rem"}
        fontWeight={"700"}
        fontSize={"15px"}
        color="#344054"
        border="#D0D5DD"
        disabled={saveCandidateOpen.disabled}
        loading={saveCandidateOpen.leaveLoading}
        onClick={() => handleSaveLeave("leave")}
      />
      <CommonButton
        value={"Save"}
        width={"100%"}
        padding={"10px"}
        marginTop={"2rem"}
        fontWeight={"700"}
        fontSize={"15px"}
        disabled={saveCandidateOpen.disabled}
        loading={saveCandidateOpen.loading}
        onClick={handleSave}
      />
    </CommonGrid2>
  );

  const handleSave = async () => {
    setSaveCandidateOpen((prev) => ({
      ...prev,
      disabled: true,
      loading: true,
    }));

    try {
      let params = {
        resume_id: resumeData.id,
      };
      const data = await dispatch(ResumeIntelligenceSave(params));
      setResumeIntelligenceSave(data?.data);
      setSnackbarState({
        open: true,
        severity: "success",
        message: data.message,
      });
      handleSaveCandidateClose();
      navigate(`/candidates/candidate-view?view-id=${data?.data?.id}`);
    } catch (error) {
      setSaveCandidateOpen((prev) => ({
        ...prev,
        loading: false,
      }));
      setSnackbarState({
        open: true,
        severity: "error",
        message: error?.data?.message || error.message,
      });
    }
  };
  const handleSaveCandidateClose = () => {
    setSaveCandidateOpen({
      open: false,
      loading: false,
      disabled: false,
      leaveLoading: false,
    });
  };

  const handleSaveToCandidatehub = () => {
    // if (resumeData?.is_duplicate_present) {
    setViewResume((prev) => ({
      ...prev,
      open: true,
    }));
    // } else
    //   setSaveCandidateOpen({
    //     open: true,
    //     loading: false,
    //   });
  };

  const handleDuplicate = async (action) => {
    let params = {
      action: action,
      resume_id: resumeData.id,
    };
    setViewResume((prev) => ({
      ...prev,
      disabled: true,
      duplicateLoading: action === "duplicate" ? true : false,
      replacedLoading: action === "replaced" ? true : false,
      leaveLoading: action === "leave" ? true : false,
    }));
    try {
      // const data = await JobResumeDuplicate(params);
      // setResumeIntelligenceSave(data?.data);
      // setSnackbarState({
      //   open: true,
      //   severity: "success",
      //   message: data?.message,
      // });
      // handleViewCandidateClose();
      if (action === "leave") {
        setTimeout(() => {
          navigate("/resume-intelligence/create-candidate-resume");
          setValue(0);
          setTabData((prev) =>
            prev.map((tab, index) =>
              index === 0
                ? { ...tab, status: "In Progress" }
                : index === 1
                ? { ...tab, status: "Pending" }
                : tab
            )
          );
          handleViewCandidateClose();
        }, 1000);
      } else {
        const data = await JobResumeDuplicate(params);
        setResumeIntelligenceSave(data?.data);
        setSnackbarState({
          open: true,
          severity: "success",
          message: data?.message,
        });
        setTimeout(() => {
          navigate(`/candidates/candidate-view?view-id=${data?.data?.id}`);
          handleViewCandidateClose();
        }, 800);
      }
    } catch (error) {
      setSnackbarState({
        open: true,
        severity: "error",
        message: error.message,
      });
      setViewResume((prev) => ({
        ...prev,
        disabled: false,
        duplicateLoading: false,
        replacedLoading: false,
        leaveLoading: false,
      }));
    }
  };

  const FooterViewResume = () => (
    <CommonGrid2>
      <CommonGrid2 display={"flex"} gap={"1rem"}>
        <CommonButton
          value={"Duplicate"}
          variant="outlined"
          width={"100%"}
          padding={"10px"}
          marginTop={"2rem"}
          fontWeight={"700"}
          fontSize={"15px"}
          color="#344054"
          border="#D0D5DD"
          disabled={viewResume.disabled}
          loading={viewResume.duplicateLoading}
          onClick={() => handleDuplicate("duplicate")}
        />
        <CommonButton
          value={"Replace Existing"}
          width={"100%"}
          padding={"10px"}
          marginTop={"2rem"}
          fontWeight={"700"}
          fontSize={"15px"}
          disabled={viewResume.disabled}
          loading={viewResume.replacedLoading}
          onClick={() => handleDuplicate("replaced")}
        />
      </CommonGrid2>
      <CommonButton
        value={"Leave"}
        variant="outlined"
        width={"100%"}
        padding={"10px"}
        marginTop={"1rem"}
        fontWeight={"700"}
        fontSize={"15px"}
        color="#344054"
        border="#D0D5DD"
        disabled={viewResume.disabled}
        loading={viewResume.leaveLoading}
        onClick={() => handleDuplicate("leave")}
      />
    </CommonGrid2>
  );

  const handleViewCandidateClose = () => {
    setViewResume({
      open: false,
      disabled: false,
      duplicateLoading: false,
      replacedLoading: false,
      leaveLoading: false,
    });
  };

  const handleViewCandidate = () => {
    setViewResume((prev) => ({
      ...prev,
      open: true,
      disabled: false,
      duplicateLoading: false,
      replacedLoading: false,
      leaveLoading: false,
    }));
  };

  const handleDownloadResume = () => {
    if (resumeData?.id) {
      setDownloadMenuLoader(true);
      GETDOWNLOAD(
        DownloadResume(
          resumeData?.id
          // localStorageData?.organization === "Demo" &&
          //   localStorageData?.role === "Demo"
          //   ? resumeData?.id
          //   : resumeIntelligenceSave.id
        ),
        {
          params: {
            type: "resume",
          },
          responseType: "blob",
        }
      )
        .then((response) => {
          const contentType = response.headers["content-type"];

          const fileName = `${resumeData?.resume_file_name}`;

          const url = window.URL.createObjectURL(
            new Blob([response.data], { type: contentType })
          );
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", fileName);
          document.body.appendChild(link);
          link.click();
          link.remove();
          setDownloadMenuLoader(false);
        })

        .catch((error) => {
          if (error.response && error.response.data instanceof Blob) {
            const reader = new FileReader();
            reader.onload = () => {
              const responseText = reader.result;
              try {
                const json = JSON.parse(responseText);
                const errorMessage =
                  json.error || "An unexpected error occurred.";
                setSnackbarState({
                  open: true,
                  severity: "error",
                  message: errorMessage,
                });
              } catch (e) {
                setSnackbarState({
                  open: true,
                  severity: "error",
                  message:
                    "An unexpected error occurred while parsing the error message.",
                });
              }
            };
            reader.readAsText(error.response.data);
          } else {
            setSnackbarState({
              open: true,
              severity: "error",
              message: "An unexpected error occurred.",
            });
          }
          setDownloadMenuLoader(false);
        });
    } else {
      setSnackbarState({
        open: true,
        severity: "error",
        message: "Resume was not parsed successfully. Unable to download.",
      });
      setDownloadMenuLoader(false);
    }
  };

  const handleCloseNoteDialog = () => {
    setOpenNote({
      loading: false,
      open: false,
      note: "",
      id: "",
      created_at: "",
      deleteNote: false,
    });
  };

  const handleClickAddNote = () => {
    setOpenNote((prev) => ({
      ...prev,
      open: true,
    }));
  };

  useEffect(() => {
    if (
      value === 2 &&
      resumeIntelligenceSave &&
      resumeIntelligenceSave?.need_review !== undefined
    ) {
      handleFetchNote();
    }
    if (value === 0) {
      fetchCandidateList(limit, (candidateList.currentPage - 1) * limit);
    }
  }, [value && resumeIntelligenceSave]);

  const handleFetchNote = async () => {
    try {
      setNotesTableListLoading(true);
      const data = await ResumeIntelligenceGETNote(resumeIntelligenceSave.id);
      setNotesTableList(data.data);
      setNotesTableListLoading(false);
    } catch (error) {
      setSnackbarState({
        open: true,
        message: error.message,
        severity: "error",
      });
      setNotesTableListLoading(false);
    }
  };

  const handleSubmit = async (values) => {
    try {
      setOpenNote((prev) => ({
        ...prev,
        loading: true,
      }));
      const data = values.id
        ? await ResumeIntelligencePutNote(values.id, values)
        : await ResumeIntelligencePostNote(resumeIntelligenceSave.id, [values]);
      await handleFetchNote();
      setSnackbarState({
        open: true,
        message: data?.message || data?.data?.message,
        severity: "success",
      });
      handleCloseNoteDialog();
      navigate(`/candidates/candidate-view?view-id=${data?.id}`);
    } catch (error) {
      setSnackbarState({
        open: true,
        message: error.message,
        severity: "error",
      });
      setOpenNote((prev) => ({
        ...prev,
        loading: false,
      }));
    }
  };

  const handleUpdateNoteClick = (row) => {
    setOpenNote({
      open: true,
      note: row.note,
      id: row.id,
    });
  };

  const handleDeleteNoteClick = (row) => {
    setOpenNote((prev) => ({
      ...prev,
      deleteNote: true,
      id: row?.id,
      note: row?.note,
      created_at: row?.created_at,
    }));
  };

  const handleDeleteNoteById = async () => {
    setOpenNote((prev) => ({
      ...prev,
      loading: true,
    }));
    try {
      const data = await ResumeIntelligenceDeleteNote(openNote.id);
      await handleFetchNote();
      handleCloseNoteDialog();
      setSnackbarState({
        open: true,
        message: data.message,
        severity: "success",
      });
    } catch (error) {
      setSnackbarState({
        open: true,
        message: error.message,
        severity: "error",
      });
      setOpenNote((prev) => ({
        ...prev,
        loading: false,
      }));
    }
  };

  const QontoStepIcon = (props) => {
    const { active, completed, className } = props;
    const index = props.icon - 1;

    if (completed) {
      return <StepperActiveIco size={"28"} />;
    }
    if (active) {
      return <StepperInprogressIco size={"28"} />;
    } else return <PageStepperDefaultIco size={"28"} />;
  };

  const handleCopyMouseLeave = () => {
    setTimeout(() => setCopied(false), 200);
  };

  const handleCopyClick = async (text) => {
    try {
      await navigator.clipboard.writeText(text);
      setCopied(true);
    } catch (error) {}
  };

  const handlePageChange = (page) => {
    setCandidateList((prev) => ({
      ...prev,
      currentPage: page,
    }));
    fetchCandidateList(limit, (page - 1) * limit);
  };

  const fetchCandidateList = async (limit, offset) => {
    setCandidateList((prev) => ({
      ...prev,
      loading: true,
    }));
    try {
      let params = {
        limit: limit,
        offset: offset,
        status: "draft",
      };
      const response = await CandidateEnrichResume(params);
      const data = response.data;
      setCandidateList((prev) => ({
        ...prev,
        data: data?.results || [],
        totalPage: data?.total_pages,
        loading: false,
      }));
    } catch (err) {
      setCandidateList((prev) => ({
        ...prev,
        loading: false,
      }));
    }
  };

  const handleCandidateViewCall = async (row) => {
    setIsLoading(true);
    try {
      const data = await dispatch(CandidateViewCall(row.id));
      dispatch(
        ResumeIntelligenceUploadResume({
          data: data,
          file: [],
          status: "success",
        })
      );
      setResumeData(data);
      setIsLoading(false);
    } catch (error) {
      setSnackbarState({
        open: true,
        severity: "error",
        message: error?.data?.message || error.message,
      });
      setIsLoading(false);
    }
  };

  const handleIconClick = async (row) => {
    setViewFullRecord(false);
    setBreadCrumbShow(false);
    dispatch(
      ResumeIntelligenceUploadResume({
        status: "process",
      })
    );
    navigate(
      `/resume-intelligence/create-candidate-resume?resume=parse&resume_id=${row.id}&status=draft`
    );
    setTabData((prev) =>
      prev.map((tab, index) =>
        index <= 1
          ? { ...tab, status: "Completed" }
          : { ...tab, status: "In Progress" }
      )
    );
    setValue(2);

    handleCandidateViewCall(row);
  };

  const handleTableBodyData = (row, index) => {
    if (!row) return null;

    const handleDeleteClick = (e, row) => {
      e.stopPropagation();
      setDeleteTableRow((prev) => ({
        ...prev,
        open: true,
        content: row.job_title,
        id: row.id,
      }));
    };

    return (
      <>
        <TableCell>{row.name || "-"}</TableCell>
        <TableCell>{row.job_title || "-"}</TableCell>

        <TableCell>
          <StatusChange>
            <DotColor
              color={
                row.status === "Active"
                  ? "green"
                  : row.status === "Hold"
                  ? "orange"
                  : "#667085"
              }
            />
            {row.status || "-"}
          </StatusChange>
        </TableCell>
        <TableCell>
          <ScoreChange>{row.rice_score}%</ScoreChange>
        </TableCell>

        <TableCell>
          <CommonGrid2 alignItems={"center"} gap={"0.8rem"} display={"flex"}>
            <VisibilityOutlinedIcon
              onClick={() => (isLoading ? {} : handleIconClick(row))}
              style={{
                opacity: isLoading ? 0.3 : 1,
                cursor: isLoading ? "auto" : "pointer",
                fontSize: "21px",
              }}
            />
            <IconButton
              onClick={(e) => handleDeleteClick(e, row)}
              disabled={isLoading}
              style={{ opacity: isLoading ? 0.4 : 1 }}
            >
              <DeleteIco strokeWidth={2} />
            </IconButton>
          </CommonGrid2>
        </TableCell>
      </>
    );
  };

  const handleSourceCandidate = () => {
    navigate(
      `/candidates/candidate-view/candidate-scoring?id=${resumeData?.id}&name=${resumeData?.personal_details?.candidate_name}&title=${resumeData?.personal_details?.title}`
    );
  };

  const handleViewRecord = (data, row) => {
    if (row.name === "new_resumes") {
      setViewFullRecord(true);
    } else {
      setViewFullRecord(false);
    }
    setResumeData(data);
    navigate(`/resume-intelligence/create-candidate-resume?resume=parse&resume_id=${data.id}`);
  };

  useEffect(() => {
    setChatBotData((prev) => ({
      ...prev,
      selectedValue: "Support",
    }));

    handleSupportCall();
  }, []);

  const handleSupportCall = async () => {
    setChatBotData((prev) => ({
      ...prev,
      pageLoader: true,
      message: [
        { sender: "bot", text: "Hi, I am Hailey. How can I assist you today?" },
      ],
    }));
    try {
      const data = await SupportGetCall(localStorageData?.user_id);
      const messages = [];
      data?.history?.forEach((entry) => {
        if (entry.user) {
          const userMessage = {
            sender: "user",
            text: entry.user,
          };
          messages.push(userMessage);
        }
        if (entry.assistant) {
          const botMessage = {
            sender: "bot",
            text: entry.assistant,
          };
          messages.push(botMessage);
        }
      });

      setChatBotData((prev) => ({
        ...prev,
        message: [prev.message[0], ...messages],
        bubble: data?.data?.bubble_questions,
        pageLoader: false,
      }));
      setIsBottomVisible(false);
    } catch (error) {
      setChatBotData((prev) => ({
        ...prev,
        pageLoader: false,
      }));
      setSnackbarState({
        open: true,
        severity: "error",
        message: error?.message,
      });
    }
  };

  const handleButtonSupport = (name) => {
    setChatBotData((prev) => ({
      ...prev,
      selectedValue: name === "Report Bug" ? prev.selectedValue : name,
    }));
    if (name === "Report Bug") {
      dispatch(FeedBackButton(true));
    } else if (name === "Support") {
      handleSupportCall();
    }
  };

  const handleToggleDrawer = () => {
    setChatBotData((prev) => ({
      ...prev,
      selectedValue: "Support",
      expandDrawer: false,
    }));
    setOpen((prev) => {
      const newState = !prev;
      dispatch(MinimizeIcon(prev, newState));
      return newState;
    });
  };

  const handleSendMessage = async () => {
    if (!chatBotData.value.trim()) return;
    let payload = {
      query: chatBotData.value,
      filter_criteria: {
        type: "user_manuals",
        user_id: localStorageData?.user_id,
      },
    };

    setChatBotData((prev) => ({
      ...prev,
      message: [...prev.message, { sender: "user", text: chatBotData.value }],
      loader: true,
      value: "",
    }));

    try {
      let data = await SupportCall(payload);

      const botResponse = {
        sender: "bot",
        text: data?.data?.response,
      };
      setChatBotData((prev) => ({
        ...prev,
        message: [...prev.message, botResponse],

        loader: false,
      }));
    } catch (error) {
      const botResponse = {
        sender: "error",
        text: error?.data?.message,
      };
      setChatBotData((prev) => ({
        ...prev,
        message: [...prev.message, botResponse],

        loader: false,
        value: "",
      }));
      setSnackbarState({
        open: true,
        severity: "error",
        message: error?.message,
      });
    }
  };

  const handleChatBotChange = (event) => {
    setChatBotData((prev) => ({
      ...prev,
      value: event.target.value,
    }));
    if (event.key === "Enter") {
      handleSendMessage();
    }
  };

  const handleUpArrow = (condition) => {
    setChatBotData((prev) => ({
      ...prev,
      arrow: condition === "up" ? false : true,
    }));
  };

  const handleRequestInfo = async () => {
    setIsRequestLoading(true);
    const url = process.env.REACT_APP_URL;

    try {
      const payload = [
        {
          url: `${url}/candidate-coversheet?id=${resumeData.id}&name=${
            resumeData?.personal_details?.candidate_name
          }&org_logo_url=${encodeURIComponent(
            localStorageData?.org_logo_url
          )}&organization=${localStorageData?.org_label}`,
          resume_id: resumeData.id,
        },
      ];
      const response = await SendInterest(payload);

      setSnackbarState({
        open: true,
        message: response.message || "Request successful!",
        severity: "success",
      });
      setIsRequestLoading(false);
    } catch (error) {
      setSnackbarState({
        open: true,
        message: error.message || "Request failed!",
        severity: "error",
      });
      setIsRequestLoading(false);
    }
  };

  const handleAttachment = () => {
    setAttachmentDialog((prev) => ({
      ...prev,
      open: true,
    }));
  };

  const handleAttachmentClose = () => {
    setAttachmentDialog({
      loading: false,
      disabled: false,
      open: false,
    });
  };

  const handleAttachmentSubmit = async (values, { setFieldValue }) => {
    try {
      const updatedFiles = values.file.map((file) => ({
        ...file,
        delete: false,
      }));
      setFieldValue("file", updatedFiles);
      setAttachmentDialog((prev) => ({
        ...prev,
        loading: true,
        disabled: true,
      }));

      const formData = new FormData();

      values.file.forEach((fileObj) => {
        formData.append("file", fileObj.file);
      });
      formData.append("name", values.name);
      const data = await CandidateAttachementCreateCall(
        resumeData?.id,
        formData
      );
      await fetchAttachmentTableList(resumeData?.id);
      handleAttachmentClose();
      setSnackbarState({
        open: true,
        message: data.message,
        severity: "success",
      });
    } catch (error) {
      const updatedFiles = values.file.map((file) => ({
        ...file,
        delete: true,
      }));
      setFieldValue("file", updatedFiles);
      setAttachmentDialog((prev) => ({
        ...prev,
        loading: false,
        disabled: false,
      }));
      setSnackbarState({
        open: true,
        message: error.message,
        severity: "error",
      });
    }
  };

  const handleAttachmentIconClick = (event, rowData) => {
    setAttachementRowData(rowData);
    setAnchorEl(event.currentTarget);
  };

  const handleAttachmentTableBodyData = (row, index) => (
    <>
      <TableCell>{row.name || "-"}</TableCell>
      <TableCell>{row.type || "-"}</TableCell>
      <TableCell>{row.status || "-"}</TableCell>
      <TableCell>{row.created_by || "-"}</TableCell>
      <TableCell>
        {moment(row.created_at).format("DD MMM YYYY") || "-"}
      </TableCell>
      <TableCell>
        <MoreVertOutlinedIcon
          style={{ cursor: "pointer" }}
          onClick={(e) => handleAttachmentIconClick(e, row)}
        />

        <CustomizeMenu
          id="basic-menu"
          anchorEl={anchorEl}
          open={attachementOpen}
          onClose={() => setAnchorEl(null)}
          MenuListProps={{
            "aria-labelledby": "basic-button",
          }}
        >
          {attachmentMenuData.map((item, index) => (
            <MenuItem
              key={index}
              onClick={item.disabled ? () => {} : item.onClick}
              aria-controls={item.ariaControls}
              aria-haspopup={item.ariaHasPopup}
              aria-expanded={item.ariaExpanded}
              style={{ opacity: item.disabled ? 0.5 : 1 }}
              disabled={item?.disabled}
            >
              <StyledFlexRowView>
                {item.image}
                <Typography>{item.title}</Typography>
              </StyledFlexRowView>
            </MenuItem>
          ))}
        </CustomizeMenu>
      </TableCell>
    </>
  );

  const handelAttachmentDialogClose = () => {
    setDeleteButton({
      loading: false,
      open: false,
      content: "",
      id: "",
    });
  };

  const handleDownloadAttachment = async () => {
    try {
      setAttachementMenuLoader((prev) => ({
        ...prev,
        download: true,
      }));

      const response = await CandidateAttachementDownload(
        attachementRowData.id
      );
      let filename = attachementRowData.file_name || "download";
      const blob = await response.blob();
      const blobUrl = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = blobUrl;
      link.setAttribute("download", filename);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      URL.revokeObjectURL(blobUrl);

      setAttachementMenuLoader((prev) => ({
        ...prev,
        download: false,
      }));
      setAnchorEl(null);
    } catch (error) {
      setAttachementMenuLoader((prev) => ({
        ...prev,
        download: false,
      }));
      setSnackbarState({
        open: true,
        message: error.message,
        severity: "error",
      });
    }
  };

  const handleDeleteAttachmentClick = () => {
    setAnchorEl(null);
    setDeleteButton((prev) => ({
      ...prev,
      open: true,
      id: attachementRowData.id,
      content: attachementRowData.name,
    }));
  };

  const handleDeleteAttachment = async () => {
    try {
      setDeleteButton((prev) => ({
        ...prev,
        loading: true,
      }));
      const data = await CandidateAttachementDelete(deleteButton?.id);
      await fetchAttachmentTableList(resumeData?.id);
      handelAttachmentDialogClose();
      setSnackbarState({
        open: true,
        message: data.message,
        severity: "success",
      });
    } catch (error) {
      setDeleteButton((prev) => ({
        ...prev,
        loading: false,
      }));
      setSnackbarState({
        open: true,
        message: error.message,
        severity: "error",
      });
    }
  };

  const handleFileView = async () => {
    try {
      setAttachementMenuLoader((prev) => ({
        ...prev,
        view: true,
      }));

      const response = await CandidateAttachementDownload(
        attachementRowData.id
      );

      const blob = await response.blob();
      const blobUrl = URL.createObjectURL(blob);

      const officeViewerUrl = `https://view.officeapps.live.com/op/view.aspx?src=${encodeURIComponent(
        attachementRowData.file_path
      )}`;

      const isDocValidFile = (fileName) => {
        const ext = fileName?.trim().split(".").pop()?.toLowerCase();
        return ext && ["doc", "docx"].includes(ext);
      };

      const isPdfValidFile = (fileName) => {
        const ext = fileName?.trim().split(".").pop()?.toLowerCase();
        return ext && ["pdf"].includes(ext);
      };

      if (isDocValidFile(attachementRowData.file_name)) {
        window.open(officeViewerUrl, "_blank");
      } else if (isPdfValidFile(attachementRowData.file_name)) {
        window.open(blobUrl, "_blank");
      }
      setAnchorEl(null);
      setAttachementMenuLoader((prev) => ({
        ...prev,
        view: false,
      }));
      setTimeout(() => URL.revokeObjectURL(blobUrl), 60000);
    } catch (error) {
      setAttachementMenuLoader((prev) => ({
        ...prev,
        view: false,
      }));
      setSnackbarState({
        open: true,
        message: error.message,
        severity: "error",
      });
    }
  };

  const attachmentMenuData = [
    {
      title: "View",
      disabled: attachementMenuLoader.view || attachementMenuLoader.download,
      image: attachementMenuLoader.view ? (
        <CircularProgress
          size={20}
          thickness={5}
          style={{ color: "#667085" }}
        />
      ) : (
        <EyeIco />
      ),
      onClick: () => {
        handleFileView();
      },
    },
    {
      title: "Delete",
      image: <DeleteIco />,
      disabled: attachementMenuLoader.download || attachementMenuLoader.view,
      onClick: handleDeleteAttachmentClick,
    },
    {
      title: "Download",
      disabled: attachementMenuLoader.download || attachementMenuLoader.view,
      image: attachementMenuLoader.download ? (
        <CircularProgress
          size={20}
          thickness={5}
          style={{ color: "#667085" }}
        />
      ) : (
        <Download sx={{ fontSize: "20px" }} />
      ),
      onClick: handleDownloadAttachment,
    },
  ];

  const fetchAttachmentTableList = async (resumeId) => {
    try {
      setAttachmentList((prev) => ({
        ...prev,
        loading: true,
      }));
      const data = await CandidateAttachementTableGetCall(resumeId);
      setAttachmentList((prev) => ({
        ...prev,
        loading: false,
        data: data?.data,
      }));
    } catch (error) {
      setAttachmentList((prev) => ({
        ...prev,
        loading: false,
      }));
      setSnackbarState({
        open: true,
        message: error.message,
        severity: "error",
      });
    }
  };

  const handleEditCandidate = () => {
    setEditDialog((prev) => ({
      ...prev,
      open: true,
    }));
  };

  const handleEditCandidateClose = () => {
    setEditDialog({
      open: false,
      disabled: false,
      cancelLoading: false,
      saveLoading: false,
    });
  };

  const handleEditCandidateCloseBtn = () => {
    setEditDialog((prev) => ({
      ...prev,
      disabled: true,
      cancelLoading: true,
    }));
    setTimeout(() => {
      handleEditCandidateClose();
    }, 1000);
  };

  const handleEditCandidateSubmit = async (values, initialValues) => {
    try {
      const payload = {
        candidate_first_name: {
          old_value: initialValues.candidate_first_name,
          new_value: values.candidate_first_name,
        },
        candidate_middle_name: {
          old_value: initialValues.candidate_middle_name,
          new_value: values.candidate_middle_name,
        },
        candidate_last_name: {
          old_value: initialValues.candidate_last_name,
          new_value: values.candidate_last_name,
        },

        email: {
          old_value: initialValues.email,
          new_value: values.email,
        },
        location: {
          old_value: initialValues.location,
          new_value: values.location,
        },
        title: {
          old_value: initialValues.title,
          new_value: values.title,
        },
        pay_rate: {
          new_value: {
            min: values.min.toString(),
            max: values.max.toString(),
            currency: values.rate,
          },
          old_value: {
            min: initialValues.min.toString(),
            max: initialValues.max.toString(),
            currency: initialValues.rate,
          },
        },
        source_name: {
          old_value: initialValues.source_name,
          new_value: values.source_name,
        },
        source_type: {
          old_value: initialValues.source_type,
          new_value: values.source_type,
        },
        country: values.country,
      };
      setEditDialog((prev) => ({
        ...prev,
        disabled: true,
        saveLoading: true,
      }));
      let data = await CandidateEditProfile(resumeData.id, payload);
      await handleCandidateViewCall(resumeData);
      handleEditCandidateClose();
      setSnackbarState({
        open: true,
        message: data?.message,
        severity: "success",
      });
    } catch (error) {
      setSnackbarState({
        open: true,
        message: error.message,
        severity: "error",
      });
      setEditDialog((prev) => ({
        ...prev,
        disabled: false,
        cancelLoading: false,
        saveLoading: false,
      }));
    }
  };

  const handleChangeStatus = async (e) => {
    setStatusDialog((prev) => ({
      ...prev,
      open: true,
      value: e.target.value,
    }));
  };

  const handleStatusChange = async (condition) => {
    if (condition === "no") {
      setStatusDialog((prev) => ({
        ...prev,
        noLoading: true,
        disabled: true,
      }));
      setTimeout(() => {
        handleStatusClose();
      }, 1000);
    } else if (condition === "yes") {
      setStatusDialog((prev) => ({
        ...prev,
        yesLoading: true,
        disabled: true,
      }));
      try {
        let payload = {
          status: statusDialog.value,
          id: resumeData.id,
        };
        const data = await CandidateStatusChange(payload);
        setSnackbarState({
          open: true,
          severity: "success",
          message: data.message,
        });
        handleStatusClose();
        await handleCandidateViewCall(resumeData);
      } catch (error) {
        setSnackbarState({
          open: true,
          severity: "error",
          message: error.message,
        });
        setStatusDialog((prev) => ({
          ...prev,
          yesLoading: false,
          disabled: false,
        }));
      }
    }
  };

  const SatusFooter = () => (
    <CommonGrid2 display={"flex"} gap={"1rem"}>
      <CommonButton
        value={"No"}
        variant="outlined"
        width={"100%"}
        padding={"10px"}
        marginTop={"2rem"}
        fontWeight={"700"}
        fontSize={"15px"}
        color="#344054"
        border="#D0D5DD"
        disabled={statusDialog.disabled}
        loading={statusDialog.noLoading}
        onClick={() => handleStatusChange("no")}
      />
      <CommonButton
        value={"Yes"}
        width={"100%"}
        padding={"10px"}
        marginTop={"2rem"}
        fontWeight={"700"}
        fontSize={"15px"}
        disabled={statusDialog.disabled}
        loading={statusDialog.yesLoading}
        onClick={() => handleStatusChange("yes")}
      />
    </CommonGrid2>
  );

  const handleStatusClose = () => {
    setStatusDialog({
      open: false,
      disabled: false,
      noLoading: false,
      yesLoading: false,
      value: "",
    });
  };

  const handleInteractionAction = (data) => {
    setInterAction({ data: data, open: true });
  };

  const handleInteractionTableBodyData = (row) => {
    return (
      <>
        <StyledTableBodyTableCell>{row.order_no}</StyledTableBodyTableCell>
        <StyledTableBodyTableCell>{row.created_by}</StyledTableBodyTableCell>
        <StyledTableBodyTableCell>{row.type}</StyledTableBodyTableCell>
        <StyledTableBodyTableCell>{row.action}</StyledTableBodyTableCell>
        <TableCell>
          <CommonGrid2
            display={"flex"}
            border="1px solid #D0D5DD"
            color="#344054"
            width="max-content"
            alignItems="center"
            borderRadius="5px"
            padding="2px 5px"
            gap="5px"
            boxShadow="0px 0px 1px 0px #101828"
            fontSize="13px"
          >
            <DotColor color={"green"} />
            {row.status}
          </CommonGrid2>
        </TableCell>
        <StyledTableBodyTableCell>{row.created_at}</StyledTableBodyTableCell>

        <TableCell>
          {row.updated_fields.length !== 0 && (
            <IconButton
              onClick={() => {
                handleInteractionAction(row);
              }}
            >
              <EyeIco />
            </IconButton>
          )}
        </TableCell>
      </>
    );
  };

  const handleDeleteTableClose = () => {
    setDeleteTableRow({
      open: false,
      loading: false,
      content: "",
      id: "",
    });
  };

  const handleDeleteRow = async () => {
    try {
      setDeleteTableRow((prev) => ({
        ...prev,
        loading: true,
      }));
      let payload = {
        is_draft: true,
      };
      let data = await CandidateDelete(deleteTableRow.id, payload);
      setCandidateList((prev) => ({
        ...prev,
        currentPage:
          candidateList.currentPage === 1
            ? 1
            : candidateList.data?.length === 1
            ? candidateList.currentPage - 1
            : candidateList.currentPage,
      }));
      let page =
        candidateList.currentPage === 1
          ? 1
          : candidateList.data?.length === 1
          ? candidateList.currentPage - 1
          : candidateList.currentPage;

      if (query.get("status") === "draft") {
        setSnackbarState({
          open: true,
          message: data?.message,
          severity: "success",
        });
        handleDeleteTableClose();
        setTimeout(() => {
          navigate("/resume-intelligence/create-candidate-resume");
        }, 1000);
      } else {
        fetchCandidateList(limit, (page - 1) * limit);

        setSnackbarState({
          open: true,
          message: data?.message,
          severity: "success",
        });
        handleDeleteTableClose();
      }
    } catch (error) {
      setSnackbarState({
        open: true,
        message: error.message,
        severity: "error",
      });
      setDeleteTableRow((prev) => ({
        ...prev,
        loading: false,
      }));
    }
  };

  const handleDeleteCandidate = () => {
    setDeleteTableRow((prev) => ({
      ...prev,
      open: true,
      content: resumeData?.personal_details?.inferred_title,
      id: resumeData.id,
    }));
  };

  const handleExpandDrawer = () => {
    setChatBotData((prev) => ({
      ...prev,
      expandDrawer: !prev.expandDrawer,
    }));
  };

  const handleGoToJob = (row, condition) => {
    const URL = process.env.REACT_APP_URL;
    window.open(
      `${URL}/jobs/jobs-view?id=${row.id}&title=${row.job_title}&value=1`,
      "_blank",
      "noopener,noreferrer"
    );
  };
  return (
    <CustomDiv
      background="#F6F8FB"
      height={"100vh"}
      overflowY="auto"
      display="flex"
      ref={ref}
    >
      <CommonGrid2
        width={
          open
            ? `calc(100% - ${chatBotData.expandDrawer ? "450px" : "350px"})`
            : "100%"
        }
        border={"1px solid rgba(0, 0, 0, 0.12)"}
        background="#fff"
        borderRadius={"10px"}
        height={"fit-content"}
        padding={"1rem"}
        margin={"1.35rem 1rem 1.35rem 1.35rem"}
        position={"relative"}
        sx={{
          transition: theme.transitions.create(["width"], {
            duration: theme.transitions.duration.short,
            easing: theme.transitions.easing.easeInOut,
          }),
        }}
      >
        {/* <Grid2 container spacing={3} padding={"2rem"}> */}
        <Grid2 size={12}>
          <Typography fontSize={"24px"} fontWeight={600}>
            {"Resume Intelligence Engine Module"}
          </Typography>
        </Grid2>
        <Grid2 size={12}>
          <Box width={"100%"}>
            <StepperStyle
              activeStep={value}
              margin={value === 2 && "1rem  0px 2rem"}
            >
              {tabData.map((step, index) => (
                <Step
                  key={step.label}
                  style={{
                    padding:
                      index === 2
                        ? "0px 0px 0px 1.2rem"
                        : index === 0
                        ? "0px 1.2rem 0px 0px"
                        : "0px 1.2rem",
                  }}
                >
                  <StepLabel StepIconComponent={QontoStepIcon}>
                    <CommonGrid2
                      display="flex"
                      flexDirection="column"
                      gap="5px"
                      justifyContent={"center"}
                      alignItems={"center"}
                    >
                      <Typography
                        variant="span"
                        color="#344054"
                        fontWeight={600}
                      >
                        {step.label}
                      </Typography>

                      <Typography
                        variant="span"
                        color={
                          step.status === "Completed"
                            ? "#17B26A"
                            : step.status === "In Progress"
                            ? "#7F56D9"
                            : "#5B738B"
                        }
                      >
                        {step.status}
                      </Typography>
                    </CommonGrid2>
                  </StepLabel>
                </Step>
              ))}
            </StepperStyle>
            {(value === 0 || value === 1) && (
              <Fragment>
                <UploadCandidateResume
                  handleDragOver={handleDragOver}
                  handleDragLeave={handleDragLeave}
                  handleDrop={handleDrop}
                  handleFileUpload={handleFileUpload}
                  isDragging={isDragging}
                  files={files}
                  handleDeleteFile={handleDeleteFile}
                  handleNextUploadClick={handleNextUploadClick}
                  isLoading={isLoading}
                />
                <CommonTable
                  data={candidateList.data}
                  columns={headerData}
                  handleTableBodyData={handleTableBodyData}
                  paginationProps={{
                    count: candidateList.totalPage,
                    page: candidateList.currentPage,
                    onPageChange: (page) => handlePageChange(page),
                  }}
                  withPagination={true}
                  loading={candidateList.loading}
                  loadingRowLength={5}
                  customStyle={{
                    "& .MuiTableRow-root": {
                      cursor: "pointer",
                    },
                    "& .MuiTableRow-head": {
                      cursor: "auto",
                    },
                  }}
                  handleRowClick={handleIconClick}
                />
              </Fragment>
            )}

            {value === 2 && (
              <Fragment>
                {window.location.search.includes("value=2") && (
                  <CandidateResume
                    gridData={gridData}
                    reviewGridData={reviewGridData}
                    scoringResult={scoringResult}
                    handleViewRecord={handleViewRecord}
                    handleDetails={handleDetails}
                  />
                )}

                {window.location.search.includes("resume=parse") && (
                  <Fragment>
                    {breadCrumbShow && (
                      <CommonGrid2
                        margin="1rem 0px"
                        container
                        justifyContent={"space-between"}
                        alignItems={"center"}
                        gap={"1rem"}
                        onClick={() =>
                          navigate(
                            "/resume-intelligence/create-candidate-resume?value=2"
                          )
                        }
                      >
                        <Breadcrumbs breadCrumbData={breadCrumbData} />
                        <CommonButton
                          value={"Back"}
                          gap={"0px"}
                          padding={"5px 1rem"}
                          startIcon={<ArrowBackIcon />}
                        />
                      </CommonGrid2>
                    )}
                    <ReviewCandidateProfile
                      resumeData={resumeData}
                      isLoading={isLoading || resumeLoading}
                      handleScoreFix={handleScoreFix}
                      fixLoading={fixLoading}
                      handleSaveToCandidatehub={handleSaveToCandidatehub}
                      handleViewCandidate={handleViewCandidate}
                      handleDownloadResume={handleDownloadResume}
                      downloadMenuLoader={downloadMenuLoader}
                      handleClickAddNote={handleClickAddNote}
                      resumeIntelligenceSave={resumeIntelligenceSave}
                      notesTableList={notesTableList}
                      notesTableListLoading={notesTableListLoading}
                      handleUpdateNoteClick={handleUpdateNoteClick}
                      handleDeleteNoteClick={handleDeleteNoteClick}
                      noteHeaderData={noteHeaderData}
                      handleCopyClick={handleCopyClick}
                      handleCopyMouseLeave={handleCopyMouseLeave}
                      copied={copied}
                      //sfs
                      profileMenuDisable={viewFullRecord}
                      resumeIntelligenceCondition={
                        viewFullRecord ? false : true
                      }
                      alreadyDataHave={viewFullRecord ? true : false}
                      request_info_disabled={viewFullRecord ? false : true}
                      request_info={"Check Interest"}
                      handleRequestInfo={handleRequestInfo}
                      isRequestLoading={isRequestLoading}
                      handleAttachment={handleAttachment}
                      handleAttachmentTableBodyData={
                        handleAttachmentTableBodyData
                      }
                      handleTableBodyData={handleInteractionTableBodyData}
                      statusOptions={statusOptions}
                      handleChangeStatus={handleChangeStatus}
                      interactionHeaderdata={interactionHeaderdata}
                      handleEditCandidate={handleEditCandidate}
                      handleEditCandidateSubmit={handleEditCandidateSubmit}
                      handleEditCandidateCloseBtn={handleEditCandidateCloseBtn}
                      handleEditCandidateClose={handleEditCandidateClose}
                      attachmentList={attachmentList}
                      attachementHeaderData={attachementHeaderData}
                      handleDeleteCandidate={handleDeleteCandidate}
                      deleteIconvisible={
                        window.location.search.includes("status=draft")
                          ? true
                          : false
                      }
                      handleSourceCandidate={handleSourceCandidate}
                      bounds={bounds}
                      handleGoToJob={handleGoToJob}
                    />
                  </Fragment>
                )}
              </Fragment>
            )}
          </Box>
        </Grid2>
      </CommonGrid2>
      <CommonGrid2
        sx={{
          transition: theme.transitions.create(["width"], {
            duration: theme.transitions.duration.short,
            easing: theme.transitions.easing.easeInOut,
          }),
        }}
        width={open ? (chatBotData.expandDrawer ? "450px" : "350px") : "0px"}
        border={"1px solid rgba(0, 0, 0, 0.12)"}
        background="#fff"
        top={"0px"}
        position={"sticky"}
        right={"0"}
        height={"100%"}
        overflowY={"auto"}
        scrollStyle
        scrollBar="5px"
      >
        <CommonGrid2
          padding={"0rem 1rem 1rem"}
          height={"100%"}
          justifyContent={"space-between"}
          display={"flex"}
          flexDirection={"column"}
        >
          <SideBarChatBot
            handleToggleDrawer={handleToggleDrawer}
            jobId={""}
            // height={minimizeScreen}
            chatBotData={chatBotData}
            // handleChatBotFetchData={handleChatBotFetchData}
            handleSendMessage={handleSendMessage}
            handleChatBotChange={handleChatBotChange}
            isBottomVisible={isBottomVisible}
            setIsBottomVisible={setIsBottomVisible}
            handleUpArrow={handleUpArrow}
            userName={localStorageData?.username}
            buttonSupport={buttonSupport}
            handleButtonSupport={handleButtonSupport}
            handleExpandDrawer={handleExpandDrawer}
          />
        </CommonGrid2>
      </CommonGrid2>
      <SnackBar
        snackbarState={snackbarState}
        handleCloseValidation={handleCloseValidation}
      />
      <DialogCandidateHub
        open={fixOpen}
        handleClose={handleFixClose}
        footer={<Footer />}
        icon={<CandidateHub margin={"10px 0px 0px 10px"} />}
        title="Save to Candidate Hub?"
        titlepadding={"0px 0px 16px"}
        content={
          <>
            Save the Candidate Hub to access the{" "}
            <strong style={{ fontWeight: 700 }}>Fix</strong> feature for
            correcting grammar mistakes
          </>
        }
      />

      <DialogCandidateHub
        open={saveCandidateOpen.open}
        handleClose={handleSaveCandidateClose}
        icon={<CandidateHub margin={"10px 0px 0px 10px"} />}
        footer={<SaveCandidateFooter />}
        title="Save to Candidate Hub?"
        titlepadding={"0px 0px 16px"}
        content={
          <>
            You are about to save a candidate under the name{" "}
            <strong style={{ fontWeight: 700 }}>
              {resumeData?.personal_details?.candidate_name}
            </strong>{" "}
            and the role{" "}
            <strong style={{ fontWeight: 700 }}>
              {resumeData?.personal_details?.inferred_title}
            </strong>{" "}
            in the Candidate Hub.
          </>
        }
      />

      <DialogCandidateHub
        open={viewResume.open}
        handleClose={handleViewCandidateClose}
        icon={<CandidateHub margin={"10px 0px 0px 10px"} />}
        footer={<FooterViewResume />}
        title="Candidate Already Exists"
        titlepadding={"0px 0px 16px"}
        content={
          <>
            You are about to save a candidate under the name{" "}
            <strong style={{ fontWeight: 700 }}>
              {resumeData?.personal_details?.candidate_name}
            </strong>{" "}
            and the role{" "}
            <strong style={{ fontWeight: 700 }}>
              {resumeData?.personal_details?.inferred_title}
            </strong>{" "}
            in the Candidate Hub.
          </>
        }
      />

      <ResumeCreateNote
        openNoteDialog={openNote.open}
        handleCloseNoteDialog={handleCloseNoteDialog}
        openNote={openNote}
        handleSubmit={handleSubmit}
      />
      <NewDeleteNote
        deleteNoteDialogOpen={openNote.deleteNote}
        handleDeleteNoteDialogClose={handleCloseNoteDialog}
        noteList={openNote}
        handleDeleteNoteById={handleDeleteNoteById}
        noteLoading={openNote.loading}
      />

      <AttachmentDialog
        open={attachmentDialog.open}
        handleClose={handleAttachmentClose}
        handleSubmit={handleAttachmentSubmit}
        attachmentDialog={attachmentDialog}
      />

      <SkillDeleteDialog
        deleteDialog={deleteButton.open}
        handleDeleteDialogClose={handelAttachmentDialogClose}
        handleDeleteSkill={handleDeleteAttachment}
        buttonLoading={deleteButton.loading}
        title="Delete Attachment"
        content={deleteButton.content}
      />
      <InteractionDialog
        open={interAction.open}
        handleClose={() =>
          setInterAction((prev) => ({
            ...prev,
            open: false,
          }))
        }
        interActionData={interAction.data}
      />
      <EditCandidateProfile
        open={editDialog.open}
        editDialog={editDialog}
        matchedData={resumeData}
        handleClose={handleEditCandidateClose}
        handleEditCandidateCloseBtn={handleEditCandidateCloseBtn}
        handleSubmit={handleEditCandidateSubmit}
        candidateDetailsEdit={true}
      />

      <DialogCandidateHub
        open={statusDialog.open}
        handleButttonClose={handleStatusClose}
        footer={<SatusFooter />}
        title={"Do you want to confirm this"}
        titlepadding={"1rem 0px 0px"}
      />
      <SkillDeleteDialog
        deleteDialog={deleteTableRow.open}
        handleDeleteDialogClose={handleDeleteTableClose}
        handleDeleteSkill={handleDeleteRow}
        buttonLoading={deleteTableRow.loading}
        title={"Delete Candidate"}
        content={deleteTableRow.content}
      />
      {!open && (
        <ChatBotLabelText
          title={"My name is Hailey. Ask me about this Candidate"}
          chatBotData={chatBotData}
          handleToggleDrawer={handleToggleDrawer}
        />
      )}
    </CustomDiv>
  );
}

export default CreateCandidateResume;
